export default __webpack_public_path__ + "static/media/lottecinema.08167da6.png";